import $ from 'jquery';

const headerTop = {
  onScroll() {
    $(window).scroll( () => {

    const pageTop = $(window).scrollTop();
    const navTop  = $('.nav__top');

      if ( pageTop > 20 ) {
        navTop.addClass('nav__top--hidden');
      } else if (pageTop === 0 ) {
        navTop.removeClass('nav__top--hidden');
      }
    });
  }
};

export default headerTop;
